import React from 'react';
import WasteAssistant from './components/WasteAssistant';

function App() {
  return (
    <div className="App">
      <WasteAssistant />
    </div>
  );
}

export default App;
